export const CLEAR_API_ERROR = 'API/CLEAR_ERROR';
